// extracted by mini-css-extract-plugin
module.exports = {"cihawt5":"cihawt5","h13x6jj9":"h13x6jj9"};